export const GET_RAFFLE_SLOTS = "GET_RAFFLE_SLOTS";
export const GET_RAFFLE_SLOTS_SUCCESS = "GET_RAFFLE_SLOTS_SUCCESS";
export const GET_RAFFLE_SLOTS_ERROR = "GET_RAFFLE_SLOTS_ERROR";
export const UPDATE_RAFFLE_WINNERS = "UPDATE_RAFFLE_WINNERS";
export const UPDATE_RAFFLE_WINNERS_SUCCESS = "UPDATE_RAFFLE_WINNERS_SUCCESS";
export const UPDATE_RAFFLE_WINNERS_ERROR = "UPDATE_RAFFLE_WINNERS_ERROR";

export const getRaffleSlotsAction = (payload) => ({
  type: GET_RAFFLE_SLOTS,
  payload,
});

export const getRaffleSlotsSuccessAction = (payload) => ({
  type: GET_RAFFLE_SLOTS_SUCCESS,
  payload,
});

export const getRaffleSlotsErrorAction = (payload) => ({
  type: GET_RAFFLE_SLOTS_ERROR,
  payload,
});

export const updateRaffleWinnersAction = (payload) => ({
  type: UPDATE_RAFFLE_WINNERS,
  payload,
});

export const updateRaffleWinnersSuccessAction = (payload) => ({
  type: UPDATE_RAFFLE_WINNERS_SUCCESS,
  payload,
});

export const updateRaffleWinnersErrorAction = (payload) => ({
  type: UPDATE_RAFFLE_WINNERS_ERROR,
  payload,
});
